module.exports = __webpack_public_path__ + "static/media/endava.1667aa44.svg";